import type {
    PerformanceScoreLevel,
    PerformanceScoreLevelDeletionImpact,
} from '@/types/competency/PerformanceScoreLevel';

import { api } from '@/api/api';

export interface PerformanceScoreLevelReplacePayload {
    levels: PerformanceScoreLevel[];
}

export default {
    async getPerformanceScoreLevels(): Promise<PerformanceScoreLevel[]> {
        const response = await api.get('/PerformanceScoreLevel');

        return response.data;
    },

    async replacePerformanceScoreLevels(
        payload: PerformanceScoreLevelReplacePayload,
    ): Promise<PerformanceScoreLevel[]> {
        const response = await api.put('/PerformanceScoreLevel', payload);

        return response.data;
    },

    async getPerformanceScoreLevelDeletionImpact(
        id: string,
    ): Promise<PerformanceScoreLevelDeletionImpact> {
        const response = await api.get(`/PerformanceScoreLevel/${id}/deletion-impact`);

        return response.data;
    },

    async deletePerformanceScoreLevel(
        id: string,
        replacementLevelId?: string,
    ): Promise<PerformanceScoreLevel> {
        const response = await api.delete(`/PerformanceScoreLevel/${id}`, {
            params: replacementLevelId ? { replacementLevelId } : undefined,
        });

        return response.data;
    },
};
